import Page, {
    getServerSideProps as compGetServerSideProps,
} from 'components/pages/PolicyPrivacy';

export const getServerSideProps = compGetServerSideProps;
export default Page;
